import {gql} from "@apollo/client";

// Resolved "who serves this node" (IBM-972): the backend walks
// node → ancestor node → client → region default → global fallback and reports
// the answering step in `source`. The whole field is null only when the viewer
// has no read access to the node, or when no global fallback is configured
// anywhere (a misconfigured environment) — "no service unit" is not a
// reachable state. `inheritedFrom` is set only for source ANCESTOR_NODE.
export const InstalledBaseNodeServiceUnit = gql`
    query InstalledBaseNodeServiceUnit($nodeId: ID!) {
        installedBaseNode(id: $nodeId) {
            id
            serviceUnit {
                source
                inheritedFrom {
                    id
                    title
                    pathNodes {
                        id
                    }
                }
                unit {
                    id
                    type
                    name
                    email
                    phone
                    serviceContacts {
                        id
                        name
                        email
                        phone
                        role
                    }
                }
            }
        }
    }
`;
